import NavbarMenuToggle from "common/ui/NavbarMenuToggle";
import DocsSiteLink from "docs/common/DocsSiteLink";
import React, { PureComponent} from "react";
import { Dropdown } from "react-bootstrap";
import "./Help.scss";
import { localizeCommon as localize } from "features/localization/localizeService";

export interface HelpProps {
    merchantName: string;
    isCustomer: boolean;
    supportEmail: string;
    supportPhone: string;
    supportWebsiteUrl: string;
}

const Help: React.FC<HelpProps> = props => {

    const email = props.isCustomer && props.supportEmail?.length > 0 ? props.supportEmail : "StoneXHedge@stonex.com";
    const phone = props.isCustomer && props.supportPhone?.length > 0 ? props.supportPhone : null;
    const websiteUrl = props.isCustomer && props.supportWebsiteUrl?.length > 0 ? props.supportWebsiteUrl : null;

    return <Dropdown className="help-center">
        <Dropdown.Toggle as={NavbarMenuToggle} id="help-toggle">
            <i className="material-icons">help</i>
        </Dropdown.Toggle>
        <Dropdown.Menu className="help-menu">
            <Dropdown.Header>
                <h4>{localize("Help_Header_Help")}</h4>
            </Dropdown.Header>
            <Dropdown.Divider />
            <Dropdown.Item>
                <i className="material-icons">phone</i> 
                {phone && <Phone number={phone} />} 
                {phone == null && <><Phone number="209-588-7399" /></>}
            </Dropdown.Item>

            <EmailItem address={email} subject="StoneX Hedge help" />

            {props.isCustomer && websiteUrl &&
                <LinkDropdownItem url={websiteUrl} openInNewTab>
                    <i className="material-icons">web</i> {props.merchantName} Homepage
                </LinkDropdownItem>
            }
            <Dropdown.Item as={DocsSiteLink.Home}>
                <i className="material-icons">menu_book</i> {localize("Help_Button_Documentation")}
            </Dropdown.Item>
        </Dropdown.Menu>
    </Dropdown>;
}

class Phone extends PureComponent<{number: string}> {
    render() {
        return <a href={`tel:${this.props.number}`}>{this.props.number}</a>;
    }
}

class EmailItem extends PureComponent<{address: string, subject: string}> {
    render() {
        return <LinkDropdownItem url={`mailto:${this.props.address}?subject=${this.props.subject}`}><i className="material-icons">email</i> 
            {this.props.address}
        </LinkDropdownItem>;
    }
}

interface LinkDropdownItemProps {
    url: string;
    openInNewTab?: boolean;
}
class LinkDropdownItem extends PureComponent<LinkDropdownItemProps> {

    render() {
        return <a href={this.props.url} className="dropdown-item" target={this.props.openInNewTab ? "_blank" : ""}>{this.props.children}</a>
    }
}

export default Help;